import { render, staticRenderFns } from "./Cumpleanios.vue?vue&type=template&id=736ebe66&scoped=true&"
import script from "./Cumpleanios.vue?vue&type=script&lang=js&"
export * from "./Cumpleanios.vue?vue&type=script&lang=js&"
import style0 from "./Cumpleanios.vue?vue&type=style&index=0&id=736ebe66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736ebe66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex})
